module.exports = __webpack_public_path__ + "img/credit_card_flatline.d2f9682b.svg";